import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineLogout,
  AiFillAlert,
} from "react-icons/ai";
import { CiBoxList } from "react-icons/ci";

import { PiNotebookBold } from "react-icons/pi";
import { BiNetworkChart } from "react-icons/bi";
import { BsFillBookmarkFill, BsCodeSlash } from "react-icons/bs";
import { Outlet } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { logoutAccess } from "../../../store/stateFunctions";
const { Sider, Content } = Layout;

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();

  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */ s>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={250}
        style={{ height: "100vh" }}
      >
        <div style={{ height: "100%", overflowY: "auto" }}>
          <div className="logo text-center">
            <p className="text-white   mb-0 float-end fs-4">
              {/* <span className="sm-logo">DC</span> */}
              {/* <span className="lg-logo">My Profile</span> */}
              {React.createElement(
                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: "trigger",
                  onClick: () => setCollapsed(!collapsed),
                }
              )}
            </p>
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[""]}
            onClick={({ key }) => {
              if (key === "signout") {
              } else {
                navigate(key);
              }
            }}
            items={[
              {
                key: "",
                icon: <AiOutlineUser className="fs-4" />,
                label: "My Account",
              },
              // {
              //   key: "addbusiness",
              //   icon: <PiNotebookBold className="fs-4" />,
              //   label: "List Business",
              // },
              {
                key: "totalenquiries",
                icon: <CiBoxList className="fs-4" />,
                label: "My Enquiries",
              },
              {
                key: "merchantfeedback",
                icon: <BsFillBookmarkFill className="fs-4" />,
                label: "Feedback",
              },
              {
                key: "",
                icon: <AiOutlineUser className="fs-4" />,
                label: "About Us",
              },
              {
                key: "",
                icon: <AiFillAlert className="fs-4" />,
                label: "Get Help From Yuvasarathi",
              },
            ]}
          />
        </div>
      </Sider>
      <Layout className="site-layout">
        <Content
          style={{
            // margin: "24px 16px",
            padding: 22,
            // minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default Sidebar;
